var map = {
	"./1.ts": [
		35966,
		5966
	],
	"./2000.ts": [
		12245,
		2245
	],
	"./5.ts": [
		67788,
		7788
	],
	"./56.ts": [
		39785,
		9785
	],
	"./97.ts": [
		93394,
		3394
	],
	"./index.ts": [
		4081
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 40240;
module.exports = webpackAsyncContext;